import jwtToken from "../helpers/jwtToken";

class ZendeskService {
    constructor() {
        this.retry = {
            ms: 2000,
            times: 0,
            maxTimes: 10, 
        };
    }

    authenticate(token = null) {
        // default get jwt token
        if(!token) {
            token = jwtToken.getToken();
        }

        // You can not logged in
        if(!token) {
            return;
        }

        if(this.retry.times > this.retry.maxTimes) {
            throw new Error("Authenticated fails. You maybe check your connection.");
        }
        
        try {
            window.zE?.('messenger', 'loginUser', function (callback) {
                callback(token);
            });
        } catch(e) {
            setTimeout(() => {
                this.retry.times++;

                this.authenticate();
            }, this.retry.ms);
        }
    }

    cancelAuthenticate() {
        window.zE?.('messenger', 'logoutUser');
    }

    hideZenDesk() {
        window.zE?.('messenger', 'hide');
    }

    showZenDesk() {
        window.zE?.('messenger', 'show');
    }

}

const zendeskService = new ZendeskService();

export default zendeskService;


// WEBPACK FOOTER //
// ./src/core/services/zendeskService.js